// Tampilan segmen rotasi dari server (Monitoring & rincian Per Instalasi). Teks tanggal ringkas
// ("1, 5, 7 Okt", "20 Agu-10 Sep") & jumlah hari di bulan dihitung SERVER (rotasi_cepat.py);
// di sini hanya merangkai teks & status "sedang berjalan" untuk ditampilkan.
import { formatRentangTanggal, isDateRangeOngoing } from "@/lib/datetime";

// Jaga yang dikelompokkan membawa `rentang` [[mulai, akhir], ...]; segmen lama cukup mulai/akhir.
export function segmenSedangBerjalan(s) {
    const rentang = s.rentang?.length ? s.rentang : [[s.tanggal_mulai, s.tanggal_akhir]];
    return rentang.some(([m, a]) => isDateRangeOngoing(m, a));
}

export function teksPeriodeSegmen(s) {
    const teks = s.tanggal_teks || formatRentangTanggal(s.tanggal_mulai, s.tanggal_akhir);
    if (!teks) return "";
    return s.hari_di_bulan == null ? teks : `${teks}, ${s.hari_di_bulan} hari di bulan ini`;
}
